import { render, staticRenderFns } from "./castCard.vue?vue&type=template&id=77be2c1c&"
import script from "./castCard.vue?vue&type=script&lang=js&"
export * from "./castCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports